import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import useSmenaEventsState from '../../../../hooks/useSmenaEventsState';
import { staticPath } from '../../../../schema/Environment';
import { EventsIcon, PlusIcon } from '../../model/icons';
import EventResults from './EventResults';
import EventsList from './EventsList';
import EventModal from './EventModal';
import { groupEventsByDate } from './eventDates';
import './events.css';

// Раздел «Мероприятия»: результаты командного зачёта + список + создание/редактирование.
export default function EventsContent({ shift }) {
    const eventsState = useSmenaEventsState(shift.id);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const competitionEvents = eventsState.competitionEvents || [];
    const groups = useMemo(() => groupEventsByDate(eventsState.events || []), [eventsState.events]);

    const getImageUrl = (event) => {
        const url = event.mediaFile?.mediaFileUrl;
        if (!url) return null;
        return url.startsWith('http') ? url : staticPath + url;
    };

    const openCreate = () => { setSelectedEvent(null); setModalOpen(true); };
    const openEdit = (event) => { setSelectedEvent(event); setModalOpen(true); };
    const closeModal = () => { setModalOpen(false); setSelectedEvent(null); };

    return (
        <>
            {competitionEvents.length > 0 && (
                <section className="content white" style={{ marginBottom: 18 }}>
                    <div className="ev-stitle"><EventsIcon />Результаты мероприятий</div>
                    <div className="ev-results">
                        {competitionEvents.map(event => (
                            <EventResults
                                key={event.id}
                                event={event}
                                onChangeResult={eventsState.updateCompetitionResult}
                            />
                        ))}
                    </div>
                </section>
            )}

            <section className="content white">
                <div className="ev-head">
                    <h2>Мероприятия</h2>
                    <button type="button" className="btn btn-primary" onClick={openCreate}>
                        <span className="ic"><PlusIcon /></span>
                        Добавить мероприятие
                    </button>
                </div>
                <EventsList groups={groups} getImageUrl={getImageUrl} onEdit={openEdit} />
            </section>

            <EventModal open={modalOpen} onClose={closeModal} event={selectedEvent} eventsState={eventsState} />
        </>
    );
}

EventsContent.propTypes = {
    shift: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
};
